import React from "react";

function ManageOrder() {
  return <div>Manage Orders</div>;
}

export default ManageOrder;
